import { managementCompany } from '../components/settlement-care/settlementCareData';

export interface FaqItemData {
  id: string;
  question: string;
  answer: string;
}

interface ContactLinkData {
  href: string;
  label: string;
}

interface FinalPageData {
  faqItems: readonly FaqItemData[];
  contacts: {
    telegram: ContactLinkData | null;
    max: ContactLinkData | null;
    phone: ContactLinkData | null;
  };
  managementCompany: typeof managementCompany;
  footerNavigation: readonly ContactLinkData[];
}

export const siteNavigation = [
  { href: '#village', label: 'О посёлке' },
  { href: '#communications', label: 'Коммуникации' },
  { href: '#infrastructure', label: 'Инфраструктура' },
  { href: '#genplan', label: 'Участки' },
  { href: '#lake-houses', label: 'Квартал Горизонт' },
  { href: '#purchase', label: 'Покупка' },
  { href: '#faq', label: 'FAQ' },
  { href: '#contacts', label: 'Контакты' },
] as const;

export const finalPageData: FinalPageData = {
  faqItems: [
    {
      id: 'land-status',
      question: 'Какой статус имеют земельные участки?',
      answer:
        'Участки предназначены для индивидуального жилищного строительства. На них можно построить жилой дом и зарегистрировать право собственности в установленном порядке.',
    },
    {
      id: 'own-contractor',
      question: 'Можно ли построить дом со своим подрядчиком?',
      answer:
        'На участках без подряда покупатель самостоятельно выбирает проект и строительную компанию.\n\nДля квартала "Горизонт" действуют отдельные требования к подрядчику и архитектурному облику.',
    },
    {
      id: 'construction',
      question: 'Обязательно ли сразу строить дом?',
      answer:
        'На участках без подряда покупатель самостоятельно планирует начало строительства с учётом законодательства и регламента посёлка.\n\nВ зоне с подрядом сроки определяются проектом и договором со строительной компанией.',
    },
    {
      id: 'mortgage',
      question: 'Можно ли оформить ипотеку?',
      answer:
        'Да. Возможность покупки только участка либо участка вместе со строительством дома зависит от выбранной банковской программы.\n\nОкончательное решение, ставка и размер первоначального взноса определяются банком.',
    },
    {
      id: 'maternal-capital',
      question: 'Можно ли использовать материнский капитал?',
      answer:
        'Материнский капитал может использоваться для строительства жилого дома или в составе подходящей жилищной кредитной программы. Условия необходимо согласовать с банком и Социальным фондом России.',
    },
    {
      id: 'booking',
      question: 'Можно ли забронировать участок?',
      answer:
        'Да. Бесплатная бронь действует семь дней. Также возможна платная бронь на срок до двух месяцев за 200 000 ₽.\n\nПри покупке эта сумма засчитывается в стоимость участка.',
    },
    {
      id: 'rules',
      question: 'Есть ли в посёлке правила строительства и проживания?',
      answer:
        'Да. В посёлке действует регламент, который устанавливает общие правила строительства, содержания участков, пользования дорогами и общественными территориями. С регламентом можно ознакомиться до покупки.',
    },
    {
      id: 'documents',
      question: 'Какие документы можно проверить перед сделкой?',
      answer:
        'Покупатель может заранее ознакомиться с документами на выбранный участок, условиями договора купли-продажи, регламентом посёлка и договором управления.',
    },
  ],
  contacts: {
    telegram: {
      href: 'https://t.me/+79956003109',
      label: 'Написать в Telegram',
    },
    // TODO: Add the confirmed MAX profile URL copied from the messenger profile.
    max: null,
    phone: {
      href: 'tel:+79956003109',
      label: '+7 995 600-31-09',
    },
  },
  managementCompany,
  footerNavigation: siteNavigation,
};
